import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { Icons } from "src/util/enums/fontAwesomeIcons"
import { RadioItemTable, RadioItemValue } from "src/util/types/components/sfxRadioList"
import { computed, PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxRadioSimple',
  props: {
  modelValue: {
    type: [String, Number] as PropType<RadioItemValue>,
    required: true,
  },

  options: {
    type: Object as PropType<RadioItemTable>,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const model = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})

const labelClass = computed(() => props.options?.labelClass)

//endregion

//region Functions

function click() {
  model.value = props.options?.val
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
    tag: "label",
    onClick: click
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, {
            class: _normalizeClass([labelClass.value, "sfx-radio-simple-label"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.options.label), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, { avatar: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_radio, {
            modelValue: model.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
            val: props.options?.val,
            "checked-icon": _unref(Icons).RADIO_ON,
            "unchecked-icon": _unref(Icons).RADIO_OFF,
            dense: ""
          }, null, 8, ["modelValue", "val", "checked-icon", "unchecked-icon"])
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_ripple]
  ])
}
}

})